export default "__VITE_ASSET__B4C4YwJo__"